import React, { useEffect, useState, useRef, useCallback } from 'react';
import { InnerBlocks } from '@wordpress/block-editor';
import { useEditor } from '@smartfire/gutenberg-react';

function hasScriptTagChild(node) {
    if(node) {
        for (let i = 0; i < node.children.length; i++) {
                if(node.children[i].nodeType === Node.ELEMENT_NODE && node.children[i].matches("script"))
                    return true;
            }
    }
    return false;
}

function getCurrentContainerNode(parentNode, level = 0) {
    while (parentNode != null && (!hasScriptTagChild(parentNode) || level >= 0)) {
        parentNode = parentNode.parentNode;
        if(hasScriptTagChild(parentNode)) {
            level--;
        } 
    }
    let containerNode =
        parentNode !== null
        ? parentNode.querySelector('div.smartfireBlockChildren')
        : null;
    return containerNode !== null && containerNode.parentNode === parentNode
        ? containerNode
        : null;
}

export function useChildrenBlocks({parent = false, nodeRef = undefined} = {}) {
    const { isEditing } = useEditor();
    const [domChildren, setChildrens] = useState(null);


    const Child = useCallback(function Child({elementType = 'div', index, ...props}){
        const ref = useRef();
        useEffect(() => {
            if(ref.current && domChildren && domChildren.length > 0) {
                while (ref.current.firstChild) {
//                    ref.current.removeChild(ref.current.firstChild);
                }
                ref.current.appendChild(domChildren[index]);
            }  else {
        }
        }, [ref, index]);
        return React.createElement(elementType, { ...props, ref});
    }, [domChildren]);
    
    
    const Children = useCallback(function ChildrenComponent({elementType = 'div', index, ...props}) {
        return <>
            {
                domChildren && domChildren.map((_, i) => {
                    return <Child index={i} key={i} className={props.className}/>
                })
            }
        </>;
    }, [domChildren]);
    
    
    const blockRef = nodeRef;
    useEffect(() => {
        if(!isEditing && blockRef.current) {
            const parentNode = getCurrentContainerNode(blockRef.current, parent ? 1 : 0);
            let childNodes = [];
            let recover = false;
            if(parentNode.__nodes) {
                childNodes = parentNode.__nodes;
                recover = true;
            } else {
                childNodes = parentNode.childNodes;
            }
            const nextChildren = [];
            for (let i = 0; i < childNodes.length; i++) {
                if(childNodes[i].nodeType === Node.ELEMENT_NODE)
                    nextChildren.push(childNodes[i]);
            }
            if(!recover)
                parentNode.__nodes = nextChildren;
            setChildrens(nextChildren);
        }
    }, [isEditing, parent, blockRef]);
    
    return {
        Children: isEditing ? InnerBlocks : Children, 
        blockRef,
        length: domChildren ? domChildren.length : undefined,
        Child,
        domChildren
    };

}

export function useChildBlockInfo({ref}) {
    const [id, setId] = useState(undefined);
    const [length, setLength] = useState(undefined);
    const blockRef = useRef();
    const nodeRef = ref ? ref : blockRef;
    const {domChildren} = useChildrenBlocks({parent: true, nodeRef});
    useEffect(() => {
        if(blockRef.current && domChildren) {
            const currentNode = getCurrentContainerNode(blockRef.current, 0).parentNode;
            setId(domChildren.findIndex((node) => {
                return node.isEqualNode(currentNode);
            }));
            setLength(domChildren.length);
        }
    }, [blockRef, domChildren]);
    return {blockRef: nodeRef, id, length}
}

export default useChildrenBlocks;
